export const CONTROLLER_NAME_LOGIN = 'primary-auth';
export const CONTROLLER_NAME_LOGIN_IDP_DISCOVERY = 'idp-discovery';
export const CONTROLLER_NAMES_MULTIFACTEUR = ['enroll-choices', 'enroll-totp', 'mfa-verify'];
export const CONTROLLER_NAMES_OKTA_VERIFY = ['barcode-push', 'activate-push', 'enroll-activation-link-sent', 'enroll-manual-push'];
export const CONTROLLER_NAME_WINDOWS_HELLO = 'enroll-windows-hello';
export const CONTROLLER_NAMES_GOOGLE_AUTH = ['barcode-totp', 'activate-totp', 'enroll-manual-totp'];
export const CONTROLLER_NAME_EXPIRED_PWD = 'custom-password-expired';
export const CONTROLLER_NAME_SMS_CALL = 'enroll-sms';

export const LOGIN_PAGE_TITLE_CONNEXTION = 'widgetTitleConnexion';
export const LOGIN_PAGE_TITLE_MULTIFACTEUR = 'widgetTitleMultiFacteur';
export const LOGIN_PAGE_TITLE_OKTA_VERIFY = 'widgetTitleOktaVerify';
export const LOGIN_PAGE_TITLE_WINDOWS_HELLO = 'widgetTitleWindowsHello';
export const LOGIN_PAGE_TITLE_GOOGLE_AUTH = 'widgetTitleGoogleAuthenticator';
export const LOGIN_PAGE_TITLE_EXPIRED_PWD = 'widgetTitleExpiredPassword';
export const LOGIN_PAGE_TITLE_SMS_CALL = 'widgetTitleSmsCall';

export function GetLoginTitle(controllerName: string): string {
  if (CONTROLLER_NAME_LOGIN === controllerName || CONTROLLER_NAME_LOGIN_IDP_DISCOVERY === controllerName) {
    return LOGIN_PAGE_TITLE_CONNEXTION;
  }
  if (CONTROLLER_NAMES_MULTIFACTEUR.includes(controllerName)) {
    return LOGIN_PAGE_TITLE_MULTIFACTEUR;
  }
  if (CONTROLLER_NAMES_OKTA_VERIFY.includes(controllerName)) {
    return LOGIN_PAGE_TITLE_OKTA_VERIFY;
  }
  if (CONTROLLER_NAME_WINDOWS_HELLO === controllerName) {
    return LOGIN_PAGE_TITLE_WINDOWS_HELLO;
  }
  if (CONTROLLER_NAMES_GOOGLE_AUTH.includes(controllerName)) {
    return LOGIN_PAGE_TITLE_GOOGLE_AUTH;
  }
  if (CONTROLLER_NAME_EXPIRED_PWD === controllerName) {
    return LOGIN_PAGE_TITLE_EXPIRED_PWD;
  }
  if (CONTROLLER_NAME_SMS_CALL === controllerName) {
    return LOGIN_PAGE_TITLE_SMS_CALL;
  }
  return controllerName;
}
